/* eslint-disable max-len */
import React, { useState } from "react";
import Header from "./Header";
import Button from "../../../components/Button";
// import QRCode from "react-qr-code";
import ErrorMessage from "../../../components/ErrorMessage";
import {QRCodeCanvas} from "qrcode.react";
import OtpInputField from "../../../components/OtpInput";
import { useNavigate } from "react-router-dom";

export default function Totp({
    handleSubmit,
    Qrcode,
    userData,
    submitSelected,
    otp,
    loading,
    setOtp,
    otpError,
    setsubmitSelected,
    setotpError,
    setIsLoginPage,
}) {
    const [type, settype] = useState("text");
    const navigateLogin = useNavigate();
    const isError = (key) =>
        submitSelected && !loading && (key === "" || otpError !== "");
    const handleClick = (e) => {
        settype("password");
        handleSubmit(e);
    };
    return (
        <>
            <Header />
            <div
                className="flex justify-center items-center "
                style={{ height: "90vh" }}
            >
                <div
                    className={`${Qrcode === "" ? "min-h-[320px]" : "min-h-[569px]"
                    }  min-w-[561px]  bg-[#ffff] `}
                >
                    <form className="w-fit" onSubmit={(e) => handleClick(e)}>
                        <div className="flex flex-col rounded-lg	px-[117px] w-fit ">
                            <h2 className="text-[#666666] text-xl font-normal pt-[38px] text-center">
                                OTP from Google Authenticator
                            </h2>
                            <div className="flex justify-center">
                                <p
                                    className={`text-[#666] text-center max-w-[490px] ${Qrcode === "" && "pb-[20px]"
                                    }`}
                                >
                                    {Qrcode !== ""
                                        ? "Scan the QR code using your Google Authenticator app and enter the OTP."
                                        : "Please check your Google Authenticator for the One-Time Password (OTP) "}
                                </p>
                            </div>
                            <div className="px-[13.5px]">
                                <div className="flex flex-col pt-7 pb-4">
                                    {userData.challengeName === undefined && (
                                        <div className="flex justify-center items-center py-6">
                                            <QRCodeCanvas value={Qrcode} />
                                            {/* <img className='w-[200px] h-[200px] ' src="https://s3-alpha-sig.figma.com/img/ab96/b479/4a4ce88a695716daa186b4a8c43ae099?Expires=1696809600&Signature=EU8ScR0UwAfN4ucjWwOU563opTEDT0CniHELpIDcRj1c~YYyZFQjCRe1XEX2uouqSGTcPO~OoNCevcc64PT0FA7Xjc3W6iq1YeojzOFr6C7r-gCcGlIR49~S3r9M4SW4gpveNVOlug7rly8~LYKFDhndMN0x6~tw1j4J5snCZYG9ODyMd76BgmGtkFOFto2P6P0tOfaW9x4L2yp~ML7d-wQU8sx8dKpEdxCNC3C3iyGLt1gqgdUm74~6~QM3KrKolFWX0~zfhq1tSsmpe-s2xazgr3wo96S1CFGPNGwucMUJMFYHZHB9X1L0jva9zG~bx1BF8mmqARB8~BZDYanb8A__&Key-Pair-Id=APKAQ4GOSFWCVNEHN3O4" alt="qr" /> */}
                                        </div>
                                    )}
                                    <div className="">
                                        <div className="flex flex-col w-9/12 mx-auto">
                                            <p className="text-center text-semibold pb-4">OTP</p>
                                            <div className="  w-full flex justify-center flex-col ">
                                                {/* <div className='relative'>
                                                <input id="otp" placeholder='' type='text'
                                                    onKeyDown={(e)=> e.target.value.replace(/\D/g, '')}
                                                    maxLength={6}
                                                    onFocus={()=>{
                                                        setsubmitSelected(false);
                                                        setotpError(false)
                                                
                                                    }}
                                                    value={otp} onChange={(e)=>{
                                                        setOtp(e.target.value)
                                                        settype('text')
                                                    }} className={`w-full ${isError(otp) ?'input-error':'input-border'}  px-4 rounded h-[56px] focus:outline-none focus:ring-0 focus:border-[#333232] peer`} />
                                                <label for="password" class={`px-4  absolute ${isError(otp)?'text-[#FC4523] ':'text-[#1F1F1F]'} block font-semibold text-sm duration-300 transform -translate-y-4 scale-75 top-4 z-10 origin-[0] left-2.5 peer-focus:text-[#1F1F1F] peer-focus:dark:text-[#1F1F1F] peer-placeholder-shown:scale-100 peer-placeholder-shown:translate-y-0 peer-focus:scale-75 peer-focus:-translate-y-4`}>Password</label>                                    <button type="button" className="cursor-pointer absolute top-[50%] -translate-y-[50%] right-3.5 ">
                                                    {type === 'text' ? <img loading="lazy" src="/src/assets/images/eye-open.svg" alt="password-show" className="password-show" onClick={() => settype('password')} />
                                                        : <img loading="lazy" src={ `/src/assets/images/${isError(otp)?'eye-error.svg':'eye.svg'}`} alt="password-hide" className="password-show" onClick={() => settype('text')} />}
                                                </button>
                                            </div> */}
                                                <OtpInputField
                                                    onChange={setOtp}
                                                    inputs={otp}
                                                    setInputs={setOtp}
                                                    value={otp}
                                                    inputType="tel"
                                                    shouldAutoFocus
                                                    inputStyle="w-14 h-12 border-b-2 sm:mr-6 mr-5 border-[#A9B2BE] bg-[transparent] outline-0 text-center text-xs4 font-normal otp-input err-otp text-[#0D1B2A]"
                                                    numInputs={6}
                                                    error={isError(otp)}
                                                    otpError={otpError}
                                                    seterror={() => setsubmitSelected(false)}
                                                    setotpError={setotpError}
                                                    renderInput={(props) => <input {...props} />}
                                                    separator={<span></span>}
                                                />
                                                <div className="flex justify-center">
                                                    {submitSelected && otpError !== "" && (
                                                        <ErrorMessage
                                                            classKey={
                                                                "itext-f4 text-sm font-semibold text-[#FC4523] mt-[16px] login-err"
                                                            }
                                                            error
                                                            message={otpError}
                                                        />
                                                    )}
                                                </div>

                                            </div>
                                        </div>

                                        <Button
                                            text="Verify"
                                            type={"submit"}
                                            disabled={loading}
                                            handleClick={handleClick}
                                            testId={"submit-otp-btn"}
                                            loading={loading}
                                            classKey={`flex item-center rounded ${Qrcode === "" ? " mb-[38px] " : ""
                                            } mt-8 justify-center w-[300px] mx-auto ${isError(otp)
                                                ? "bg-[#9E2064] opacity-[0.3]"
                                                : "bg-[#9E2064]"
                                            } py-3 rounded-lg mt-5 text-f2 font-semibold text-[#ffffff] login`}
                                        />
                                        <div
                                            className="flex space-x-[4px] justify-center items-center mt-[4px] mb-[18px] cursor-pointer"
                                            onClick={() => {setIsLoginPage(true); setOtp(Array(6).fill(""))}}
                                        >
                                            <img
                                                src="../../assets/images/arrow-left.png"
                                                alt="left-arrow"
                                            />
                                            <p className="font-minionpro font-semibold text-xs" >
                                                Return to Sign in
                                            </p>
                                        </div>
                                    </div>
                                </div>
                            </div>
                        </div>
                    </form>
                </div>
            </div>
        </>
    );
}
